import { captureUnexpectedClientError } from '@util/sentry';

const MAINTENANCE_MESSAGE =
  'Our engineers are currently performing maintenance on the site. Sorry for any inconvenience.';

const NON_USER_FACING_PATTERN =
  /is not a function|cannot read propert|objects are not valid|upload succeeded but no asset|network error|request failed with status code/i;

/** Coerce anything we might toast or display into a plain string. */
export function toErrorMessage(err, fallback = 'Something went wrong') {
  if (err == null || err === '') return fallback;
  if (typeof err === 'string') return err;
  if (typeof err === 'number' || typeof err === 'boolean') return String(err);
  if (err instanceof Error && err.message) return err.message;
  if (typeof err?.message === 'string' && err.message) return err.message;
  if (typeof err?.response_message === 'string' && err.response_message) {
    return err.response_message;
  }
  try {
    const asJson = JSON.stringify(err);
    if (asJson && asJson !== '{}') return asJson;
  } catch (_exception) {
    // ignore
  }
  return fallback;
}

/** True for API envelope messages safe to show in a toast. */
export function isUserFacingApiMessage(err) {
  if (typeof err !== 'string') return false;
  const message = err.trim();
  if (!message) return false;
  if (message === MAINTENANCE_MESSAGE) return false;
  if (NON_USER_FACING_PATTERN.test(message)) return false;
  return true;
}

/**
 * Toast only real API/business messages.
 * Unexpected client/runtime failures go to Sentry (no user toast).
 */
export function notifyUserFacingError(err, toast, context = {}) {
  if (isUserFacingApiMessage(err)) {
    toast.error(err);
    return;
  }

  captureUnexpectedClientError(
    err instanceof Error ? err : new Error(toErrorMessage(err)),
    { source: 'user_facing_gate', ...context },
  );
}
